import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, X } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Córdoba'
}, {
  name: 'Laura',
  city: 'Buenos Aires'
}, {
  name: 'Sofía',
  city: 'Rosario'
}, {
  name: 'Valentina',
  city: 'Mendoza'
}, {
  name: 'Camila',
  city: 'Tucumán'
}, {
  name: 'Martina',
  city: 'Santa Fe'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 30000);
    // Recurring interval
    const interval = setInterval(() => {
      showPopup();
    }, 30000); // Show every 30 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-start gap-4 max-w-sm" data-id="element-2">
          <div className="bg-brand-violet/10 p-2 rounded-full mt-1" data-id="element-3">
            <MapPin className="w-5 h-5 text-brand-violet" data-id="element-4" />
          </div>
          <div className="flex-1" data-id="element-5">
            <p className="text-sm font-semibold text-brand-black" data-id="element-6">
              {currentBuyer.name} de {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-7">
              Acaba de comprar el Megapack Elite
            </p>
            <p className="text-xs text-brand-gold font-medium mt-1" data-id="element-8">
              Hace unos minutos
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-9">
            <X className="w-4 h-4" data-id="element-10" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}